const category = [
    {
        display: "Tshirt small",
        categorySlug: "ao-thun"
    },
    {
        display: "Tshirt long ",
        categorySlug: "ao-somi"
    },
    {
        display: "bantalon jeance",
        categorySlug: "quan-jean"
    }
]

export default category